import { styler, timeline } from 'popmotion';
import { tweenUp, setLabels } from "./animations";
import debounce from 'lodash/debounce';
/* eslint no-console: "off", no-unused-vars: "off" */

const completeEvent = new CustomEvent('animateBlocksComplete');
const progressEvent = new CustomEvent('animateBlocksProgress');

const animate = (containers) => {
    containers.forEach((container) => {
        if (container.children.length === 0) return;

		let animateBlocks = [...container.children]
            .reduce((acc, el) => {
                if ('animateBlocksIgnore' in el.dataset) return acc; // pass data-animate-blocks-ignore
                if ('animateBlocks' in el.dataset) return acc; // pass already animated

                el.dataset.animateBlocks = 'true'; // mark as animated

                acc.push(el);
                return acc;
            }, []);

        if (animateBlocks.length === 0) return;
            
        animateBlocks = animateBlocks.map(styler);

		const animateBlocksLabels = setLabels(animateBlocks, 'animate__child');

		const setStylers = (v) => {
			animateBlocksLabels.forEach((label, i) => {
				if (v[label] !== undefined) {
					animateBlocks[i].set(v[label])
				}
			});
		};

        const onUpdate = (v) => {
            dispatchEvent(progressEvent);
            return setStylers(v);
        }

		const showAnimateBlocks = () => {
			timeline([
				[...animateBlocks.map((product, i) => tweenUp(animateBlocksLabels[i]), 600, 150), 100]
			]).start({
                update: onUpdate,
                complete: () => dispatchEvent(completeEvent),
            });
		};

		showAnimateBlocks();
	});
};

function animateBlocks() {
    const containersInit = [...document.querySelectorAll('.animate__parent')]
        .reduce((acc, el) => {
            if (!el.children.length) return acc;
            
            acc.push(el);
            return acc;
        }, []);
    if (!containersInit.length) return;
    animate(containersInit);
}

const animateDebounced = debounce(animateBlocks, 20);

const animateBlocksMixin = {
    mounted() {
        animateBlocks();
    },
}

export {
    animateBlocksMixin,
};

export default {
    install(Vue) {
        Vue.mixin(animateBlocksMixin);
    }
};
